<template>
  <div v-if="contentTable.length > 0">
    <table class="custom-table table table-borderless">
      <thead>
        <tr>
          <th v-for="(head, index) in headList" :key="index" scope="col">
            {{ head }}
          </th>
          <!-- <th v-if="isOwner" /> -->
        </tr>
      </thead>
      <tbody>
        <tr v-for="(content, i) in contentTable" :key="i">
          <td>{{ content.event }}</td>
          <td>
            <template v-if="content.price">
              {{ +content.price.toFixed(2) }}
              {{ content.currency | transformToCurrencyName }}
            </template>
            <template v-else>
              N/A
            </template>
          </td>
          <td>{{ shortenAddress(content.fromAddress) }}</td>
          <td>{{ shortenAddress(content.toAddress) }}</td>
          <td>{{ content.timestamp | formatSecondsToUtcTime }}</td>
        </tr>
      </tbody>
    </table>
    <Pagination
      ref="paginate"
      class="market-pagination"
      :page-count="totalPage"
      :page="limit"
      @handlePageChange="handleChangePage"
    />
  </div>
  <div v-else>
    Trading History Not Found
  </div>
</template>

<script>
import rf from '@/requests/RequestFactory';
import Pagination from '@/components/BaseComponents/CustomPagination.vue';

const headList = ['Event', 'Price', 'From', 'To', 'Date'];
// const contentTable = [
//   ['Purchase', '400 BUNI', 'Account 1', 'Account 2', '11:01 AM 20/09/2021'],
//   ['Listing', '500 BUNI', 'Account 1', 'Account 2', '11:01 AM 20/09/2021'],
//   ['Sale', '300 BUNI', 'Account 1', 'Account 2', '11:01 AM 20/09/2021'],
//   ['Offer', '700 BUNI', 'Account 1', 'Account 2', '11:01 AM 20/09/2021'],
//   ['Event', '690 BUNI', 'Account 1', 'Account 2', '11:01 AM 20/09/2021'],
// ];
export default {
  components: { Pagination },
  props: ['nftContract', 'nftId'],
  data() {
    return {
      headList,
      contentTable: [],
      page: 1,
      limit: 10,
      totalPage: 1
    };
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    handleChangePage(pageNum) {
      this.page = pageNum;
      this.fetch();
    },
    shortenAddress(str) {
      return str ? `${str.slice(0, 4)}...${str.slice(str.length - 5)}` : str;
    },
    async fetchData() {
      const params = {
        page: this.page,
        limit: this.limit
      };
      const res = await rf
        .getRequest('GameMarketplaceRequest')
        .getItemTradingEvent(this.nftContract, this.nftId, params);
      if (res) {
        this.contentTable = res.docs;
        this.totalPage = res.totalPages;
        this.page = res.page;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/config/_variables';

.custom-table {
  background-color: #ffffff;
  border-radius: 6px;
  font-family: Inter;
  font-size: 16px;
  color: #203a54;
  thead {
    font-family: Inter-SemiBold;
    font-weight: 600;
    color: #828c9f;
    tr {
      th {
        background-color: #dfe2e8;
        &:first-child {
          border-top-left-radius: 6px;
        }
        &:last-child {
          border-top-right-radius: 6px;
        }
      }
    }
  }
  th,
  td {
    padding: 13px 22px;
  }
}
@media screen and (max-width: $breakpoint-desktop) {
  .custom-table {
    width: 100%;
    overflow-x: auto;
  }
}
</style>
